"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
let RankTag = class RankTag extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.colorManager = new ColorLibController_1.default();
    }
    get color() {
        let v = (this.scale == 'cert') ?
            this.colorManager.getCategoryFromScore(this.score) :
            this.colorManager.getRankFromScore(this.score).toString();
        return this.colorManager.getColorWithScale(v, this.scale);
    }
    get rankLabel() {
        if (this.scale == 'cert') {
            return this.colorManager.getDefaultCategory(this.colorManager.getCategoryFromScore(this.score));
        }
        else {
            return this.colorManager
                .getRankLabel(this.colorManager.getRankFromScore(this.score))
                .toUpperCase();
        }
    }
    get label() {
        if (this.mode === 'rank')
            return this.rankLabel.toUpperCase();
        if (this.mode === 'score')
            return this.score;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'std' })
], RankTag.prototype, "scale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 36 })
], RankTag.prototype, "score", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'all' })
], RankTag.prototype, "mode", void 0);
RankTag = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Tag: bmk_ui_framework_1.Tag
        },
    })
], RankTag);
exports.default = RankTag;
